import React from 'react'
import PropTypes from 'prop-types'

import ChatBubbleFilter from '@components/chat-bubble-filter/chat-bubble-filter.component'
import ChatMessageFilter from '@components/chat-message-filter/chat-message-filter.component'
import ChatMessageTime from '@components/chat-message-time/chat-message-time.component'

import useStyles from './chat-response-message.style'

const ChatResponseMessage = (props) => {
  const { message, isVisible } = props

  const { createdAt, location: messageLocation, type } = message

  const location = !!messageLocation

  const { seconds } = createdAt

  const time = seconds * 1000

  const classes = useStyles({ message })

  /* DEV-5208: bail on empty/whitespace text too, not just the
   * 'response-hidden' sentinel. Otherwise an in-flight or malformed
   * response (text=undefined/'') renders as an orphan empty bubble. */
  if (!message?.text?.trim() || message.text === 'response-hidden') return null

  return (
    <div className={classes.replyMessage}>
      <ChatBubbleFilter
        isMe
        message={message}
      >
        <ChatMessageFilter
          isVisible={isVisible}
          message={message}
        />
      </ChatBubbleFilter>
      <ChatMessageTime
        isMe
        location={location}
        time={time}
        type={type}
      />
    </div>
  )
}

ChatResponseMessage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  message: PropTypes.shape({}).isRequired
}

export default ChatResponseMessage
